export const Cancel = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.99974 5.58672L11.9497 0.636719L13.3637 2.05072L8.41374 7.00072L13.3637 11.9507L11.9497 13.3647L6.99974 8.41472L2.04974 13.3647L0.635742 11.9507L5.58574 7.00072L0.635742 2.05072L2.04974 0.636719L6.99974 5.58672Z" fill="#FF0000"/>
        </svg>
        
    )
}